// extracted by mini-css-extract-plugin
export default {"block":"AvatarPickerControl_block__uUqbr","controlsBlock":"AvatarPickerControl_controlsBlock__+gtP5"};